import Dhaqaaq from "./Dhaqaaq"
import {
    collection,
    orderBy,
    onSnapshot,
    getFirestore,
    limit,
    query
} from "firebase/firestore"
import { useEffect, useState } from "react"

function Dhaqdhaqaaq(){
    const [Dhaq, steDhaq] = useState([])
    //qeexida hore
    const db = getFirestore()
    //hellida collections
    const colref = collection(db, "transections")
    const q = query(colref, orderBy('CreatedAt',"desc"), limit(20))

    //hellida docs 
    function getdaata(){
        onSnapshot(q, (snapshot) => {
            const Dhaq1aad = []
            snapshot.docs.forEach((doc) => {
                Dhaq1aad.push({...doc.data(), id:doc.id})
            })
            steDhaq(Dhaq1aad)
        })
    }

    useEffect(() => {
        getdaata()
    }, [])

    return(
        <>
    {/* <!--------------------------falcelin ---------------> */}
    <section className="falcelin">
        <h2>Dhaqdhaqaayadii u danbeeyay</h2>
        <div className="haye">
            <div className="dad_dhan">
                {/* qof */}
                {Dhaq && Dhaq.map((qof) => 
                <Dhaqaaq qof={qof}/>
                )}
            </div>
        </div>
    </section>
        </>
    )
}


export default Dhaqdhaqaaq